import { Service } from '@roc/feature-app-core';

const url = {
  UPDATE_BORROWER_AGENT:
    '/api/v1/document/formDocument/updateBorrowerClosingAttorneyForm',
  MARK_TASK_AS_NOT_APPLICABLE: '/api/v1/taskV2/markTaskAsNotApplicable',
};

export class BorrowerClosingAgentService extends Service {
  requestBorrowerDeposit = (requestBody: any) => {
    return this.put(url.UPDATE_BORROWER_AGENT, requestBody);
  };
  markTaskAsNotApplicable = (taskId: number) => {
    return this.post(`${url.MARK_TASK_AS_NOT_APPLICABLE}/${taskId}`, {});
  };
}
